<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total" :showIndex="true" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'poolrecord',
      getListUrl: 'seerec',
      breadcrumb: [
        { name: "财务管理", path: "/finance/stabilizationFund" },
        { name: "稳定基金管理", path: "/finance/stabilizationFund" },
        { name: "提成记录" },
      ],
      cols: [
        { prop: "name", label: "司机姓名" },
        { prop: "fundmoney", label: "提成金额" },
        { prop: "month", label: "月份" },
        { prop: "addtime", label: "添加时间" },
      ],
      baseParams: ['driverid'],
    };
  },
  methods: {},
  mounted() {
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>
